/**
 * devMode.js
 *
 * Single source of truth for gating dev-only affordances in the RMS UI
 * (auto-complete buttons, demo-data generators, raw-JSON debug panels, AI
 * previews, the HFP v2 demo page, etc.).
 *
 * Policy: these affordances are available on **local development AND staging**
 * (so the internal team — e.g. reviewing the HFP v2 demo — can exercise them
 * during the UAT pilot), but NEVER in production. Some affordances render debug
 * JSON that includes referral data; that exposure is accepted on staging for the
 * internal pilot, which is why the gate must keep production excluded.
 *
 * Staging is detected via VITE_ENVIRONMENT (set in the staging env) and, as a
 * build-mode fallback, import.meta.env.MODE === 'staging' (set by
 * `vite build --mode staging`). Production is excluded because it matches none of
 * these (its VITE_ENVIRONMENT/MODE is 'production' and NODE_ENV is not
 * 'development').
 */
export const isDevAffordanceEnabled = () =>
  ['development', 'staging'].includes(import.meta.env?.VITE_ENVIRONMENT) ||
  import.meta.env?.MODE === 'staging' ||
  process.env.NODE_ENV === 'development';
